import * as _ from 'lodash';
import * as filtersForLiving from './available-filters.living';
import filtersForCommercial from './available-filters.commercial';

const commonFilters = [
  'price',
  'geo',
  'include_new_moscow',
  'from_mcad_km',
  '_highway_directions', // кастомный фильтр для групп шоссе
  'publish_period',
  'wp',
  'id_user',
  'description_exclude',
  'description_include',
  'contact',
  'id',
  'is_in_hidden_base',

  // Вся аренда
  'for_day',
];

const filtersByDealType = {
  rentLong: [
    'commission_type',
    'cl', // "Агентам не звонить"
  ],
};

const filtersByCategory = {
  flat: filtersForLiving.flat,
  suburban: filtersForLiving.suburban,
  commercial: filtersForCommercial,
};


// Фильтры, которые появляются в зависимости сразу от нескольких параметров
const conditionalFilters = {
  /** @param {QuickFiltersDealInfo} dealInfo */
  'room_type': dealInfo => (
    !dealInfo.isShortTerm &&
    _.difference(dealInfo.objectNames, ['room', 'bed']).length === 0
  ),
  'only_flat': isApartmentsVisible,
  'apartment': isApartmentsVisible,
  'penthouse': isApartmentsVisible,
};

/** @param {QuickFiltersDealInfo} dealInfo */
function isApartmentsVisible(dealInfo) {
  return !dealInfo.isShortTerm &&
    _.difference(dealInfo.objectNames, ['flat', 'flatShare']).length === 0;
}


export default angular.module('cian.newbuild.filter.availableFilters', [])
  .service('AvailableFilters', [
    'FilterTermsService',
    (FilterTermsService) => ({
      /**
       * Возвращает список фильтров для данного набора выбранных объектов
       * @memberOf AvailableFilters
       * @param {string} dealType
       * @param {boolean} isShortTerm
       * @param {string} category
       * @param {string[]} objectNames
       * @return {string[]}
       */
      getFiltersList: (dealType, isShortTerm, category, objectNames) => {
        let dealKey = dealType === 'sale' ? 'sale' :
          isShortTerm ? 'rentShort' : 'rentLong';

        const categoryFilters = filtersByCategory[category];

        const objectsFilters = _.union(
          ..._.map(objectNames, name => (categoryFilters[name] || []))
        );

        const visibleConditionalFilters = _.filter(_.keys(conditionalFilters),
          key => conditionalFilters[key]({ dealType, isShortTerm, category, objectNames })
        );

        // При переключении внутри категории стараемся сохранить как можно больше фильтров
        return _.union(
          commonFilters,
          filtersByDealType[dealKey],
          categoryFilters[dealKey],
          categoryFilters._common,
          objectsFilters,
          // Фильтры инфраструктуры (для некоторых видов коммерческой)
          FilterTermsService.getInfrastructureFor(objectNames),
          // Особые случаи
          visibleConditionalFilters,
        );
      },
    })])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/available-filters/available-filters.service.js